import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719ab004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "family-group-list" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-primary"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_5 = { class: "list-unstyled" }

import { computed, ref } from "vue"
import { useDataGroupStore } from "@/gp/DataGroupStore"
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useFamilyGroupStore } from "@/gp/FamilyGroupStore"
import { useFamilyGroupMemberStore } from "@/gp/FamilyGroupMemberStore"
import { useTokenManager } from "@/auth/TokenManager"
import { DataGroupMember, FamilyGroup, PrincipalType } from "@/gp/GroupAdminModel"
import { hideModalAsync } from "@/util/AppUtil"
import { LoadMode } from "@/util/AsyncData"
import { isDefined } from "@/util/TypeScriptUtil"
import Modal from '@/util/Modal.vue'
import FamilyGroupItem from "@/manage/familygroups/FamilyGroupItem.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupShareModal',
  props: {
  profile: Boolean
},
  emits: [
  'requestShare'
],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





__expose({
  open
})

const dataGroupIdRef = ref<string>()
const excludeIdsRef = ref<string[]>([])
const selectedFamilyGroupRef = ref<FamilyGroup>()

const modalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const tokenManager = useTokenManager()

const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(dataGroupIdRef.value, LoadMode.EnsureLoaded)?.data)
const familyGroupsRef = computed(() => {
  const members = familyGroupMemberStore.getMembersForUsers(undefined, LoadMode.EnsureLoaded)
  const familyGroupIds = members.map(fm => fm.familyGroupId!)
  return familyGroupStore.getAsyncGroupList(familyGroupIds, LoadMode.EnsureLoaded).map(a => a.data).filter(isDefined)
})
const availableFamilyGroupsRef = computed(() => familyGroupsRef.value.filter(fg => !excludeIdsRef.value.includes(fg.id!)))
const canShareRef = computed(() => !!dataGroupRef.value && !!selectedFamilyGroupRef.value)
const isFamilyGroupOwnedRef = computed(() => selectedFamilyGroupRef.value?.ownerId == tokenManager.current.userId)
const shareTextRef = computed(() => !selectedFamilyGroupRef.value || isFamilyGroupOwnedRef.value ? "Share" : "Request share")

function open(dataGroupId: string, excludeFamilyGroupIds?: string[]) {
  dataGroupIdRef.value = dataGroupId
  excludeIdsRef.value = excludeFamilyGroupIds ?? []
  selectedFamilyGroupRef.value = undefined
  modalRef.value?.open()
}

function onSelected(fg: FamilyGroup) {
  if (fg == selectedFamilyGroupRef.value) {
    selectedFamilyGroupRef.value = undefined // unselect
  } else {
    selectedFamilyGroupRef.value = fg
  }
}

async function onShare() {
  if (selectedFamilyGroupRef.value!.ownerId == tokenManager.current.userId) {
    // share now
    const member = new DataGroupMember()
    member.dataGroupId = dataGroupIdRef.value
    member.principalType = PrincipalType.FamilyGroup
    member.principalId = selectedFamilyGroupRef.value?.id
    await dataGroupMemberStore.addAsync(dataGroupIdRef.value!, member)
    modalRef.value?.close()
  }
  else {
    await hideModalAsync(modalRef.value!.$el)
    emit('requestShare', selectedFamilyGroupRef.value!.id)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "share-modal",
    "ok-disabled": !canShareRef.value,
    onOk: onShare
  }, {
    title: _withCtx(() => [
      (props.profile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Share profile")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Share your tree")
          ], 64))
    ]),
    okText: _withCtx(() => [
      _createTextVNode(_toDisplayString(shareTextRef.value), 1)
    ]),
    busyText: _withCtx(() => [
      _createTextVNode("Sharing...")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.profile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Choose a group to share this profile with. If the group is managed by someone else, we'll help you create a sharing request. ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Choose a group to share this tree with. If the group is managed by someone else, we'll help you create a sharing request. ")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_2, [
        (familyGroupsRef.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No groups are available to share with. "))
          : (availableFamilyGroupsRef.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (props.profile)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" This profile has already been shared with, or has a pending sharing request for, all groups visible to you. ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" This tree has already been shared with, or has a pending sharing request for, all groups visible to you. ")
                    ], 64))
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFamilyGroupsRef.value, (fg) => {
            return (_openBlock(), _createElementBlock("li", {
              key: fg.id,
              class: _normalizeClass({ 'selected-item': fg == selectedFamilyGroupRef.value })
            }, [
              _createVNode(FamilyGroupItem, {
                "family-group-id": fg.id,
                "select-mode": "",
                raised: fg == selectedFamilyGroupRef.value,
                onClick: ($event: any) => (onSelected(fg))
              }, null, 8, ["family-group-id", "raised", "onClick"])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})